import { useEffect, useMemo, useState } from 'react';

const SORTS = {
  newest: (a, b) => (b.created || '').localeCompare(a.created || ''),
  oldest: (a, b) => (a.created || '').localeCompare(b.created || ''),
  popular: (a, b) => (b.views || 0) - (a.views || 0),
};

// Shared search / domain / sort / pagination state for the library listing pages.
export const useLibraryList = (items, defaultPerPage = 9) => {
  const [query, setQuery] = useState('');
  const [cat, setCat] = useState('all');
  const [sort, setSort] = useState('newest');
  const [perPage, setPerPage] = useState(defaultPerPage);
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return items
      .filter(x => (cat === 'all' || x.categories.includes(cat)) &&
        (!q || [x.title.ar, x.title.en, x.excerpt.ar, x.excerpt.en].some(s => (s || '').toLowerCase().includes(q))))
      .sort(SORTS[sort]);
  }, [items, cat, query, sort]);

  useEffect(() => { setPage(1); }, [cat, query, sort, perPage]);
  const pages = Math.max(1, Math.ceil(filtered.length / perPage));
  const start = (page - 1) * perPage;
  const reset = () => { setQuery(''); setCat('all'); setSort('newest'); };

  return {
    query, setQuery, cat, setCat, sort, setSort, perPage, setPerPage, page, setPage, pages, reset,
    filtered, visible: filtered.slice(start, start + perPage), from: filtered.length ? start + 1 : 0, to: Math.min(start + perPage, filtered.length),
    dirty: query !== '' || cat !== 'all' || sort !== 'newest',
  };
};
